import { GraphSchema } from '@ta/server';

import { Revenue } from './revenue';

export interface UserFieldVisibility {
  fieldName: string;
  isPublic: boolean;
}

export interface Tenant {
  id: string;
  userId: string;
  status: string;
  createdDate: string;
  updatedDate: string;
  deleted: boolean;
  description: string;
  animals: boolean;
  smoking: boolean;
  vehicle: boolean;
  cpas: boolean;
  insurance: boolean;
  revenue: Revenue;
  fieldVisibilities: UserFieldVisibility[];
}

export const tenantBrutProps: (keyof Tenant)[] = [
  'id',
  'animals',
  'cpas',
  'description',
  'fieldVisibilities',
  'insurance',
  'revenue',
  'smoking',
  'vehicle',
];
export const tenantProps = new GraphSchema<Tenant>(tenantBrutProps);
